import React, { useEffect } from 'react';

import { StyledToast } from './Toast.styles';

import { ToastProps } from './Toast.types';

const Toast = ({
  children,
  isOpen,
  handleCloseToast,
  timer = 2000,
  componentClassname = 'toast',
  customClassnames = '',
  customStyle = '',
  ...props
}: ToastProps) => {
  useEffect(() => {
    if (isOpen) {
      const timeout = setTimeout(() => handleCloseToast(), timer);

      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  return (
    <StyledToast
      {...props}
      className={`${componentClassname} ${customClassnames} ${componentClassname}--is-${
        isOpen ? 'open' : 'close'
      }
      `}
      customStyle={customStyle}
    >
      {children}
    </StyledToast>
  );
};
Toast.displayName = 'Toast';

export default Toast;
